import React, { useState, useEffect } from "react";
import { AppProvider, useAppContext } from "@/AppContext";
import { ReactFlowProvider } from "@xyflow/react";
import SettingMaterial from "@/Pages/Project/Flow/Right/SettingMaterial";
import PageTop from "@/Pages/Project/PageTop";
import PageSeletor from "@/Pages/Project/Flow/Right/PageSeleltor";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import userInfo from "@/Components/user";
import { Button, message } from "antd";
import { updateFlow } from '@/services/common';

const Component = () => {
  const { state, actions } = useAppContext();
  const { materials, globle_physical_method, mParams } = state;
  const { setMaterials, setShowMaterialsData } = actions;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams(); // 从路由路径中提取参数
  const pid = params.k; // 对应路由中的:k（104）
  const fid = params.f;
  const { setCurPage } = actions;

  useEffect(() => {
    // 解析URL参数并更新状态
    const params = new URLSearchParams(location.search);
    // const projectId = params.get("k");
    // const flowId = params.get("f");
    const taskId = params.get("j");
    // actions.loadData();
    // 执行数据加载逻辑
  }, [location.search]);

  const handleNextStep = () => {
    setIsLoading(true);
    const global_data = {
      globle_physical_method: globle_physical_method,
      materials: materials,
    };

    // 调用API更新流程数据
    updateFlow(pid, fid, { global_data }, userInfo.access_token).then(
      (res: any) => {
        setIsLoading(false);
        if (res.status === 200) {
          // 保存成功后跳转到流程设计页面
          setCurPage({
            key: 'simulation',
            name: '流程设计',
          });
          navigate(`/project/${pid}/flow/${fid}/design1`);
        } else {
          message.error('保存失败');
        }
      }
    );
  };

  return (
    <ReactFlowProvider>
      {state.curFlow && state.curProject && state.projectList ? (
        <>
          <PageTop
            mainContent={
              <div className="settingSelectorArea">
                <PageSeletor />
              </div>
            }
          />
          <div className="mainContent">
            <div style={{ display: "flex", flexDirection: "column", width: "80%", margin: "0 auto", position: "relative" }}>
              <SettingMaterial
                materials={materials}
                setMaterials={setMaterials}
                globle_physical_method={globle_physical_method}
                userInfo={userInfo}
                mParams={mParams}
                setShowMaterialsData={setShowMaterialsData}
              />

              <div style={{ position: 'absolute', borderRadius: '0.5rem', padding: '0 0.5rem', bottom: '6rem', right: '2rem' }}>
                 {state.curFlow.job_count > 0
                    ? '' // 有任务 → 显示这个
                    : (
                      <Button type="primary" disabled={!materials.length} onClick={handleNextStep} loading={isLoading}>
                  {materials.length > 0 ? '保存并到下一步' : '请选择进料'}
                </Button>
                    )
                  }
              </div>
            </div>
          </div>
        </>
      ) : null}
    </ReactFlowProvider>
  );
};

export default Component;